export default __webpack_public_path__ + "static/media/jaga-jarak.02cd2f84.png";